const LIMIT = 240;

export function isRequestCanceled(error) {
  return (
    error?.code === "ERR_CANCELED" ||
    error?.name === "CanceledError" ||
    error?.name === "AbortError"
  );
}

function readable(value) {
  if (value == null || value === false) return "";
  if (Array.isArray(value)) return value.map(readable).filter(Boolean).join(", ");
  if (typeof value === "object") return readable(value.message || value.error || "");
  const raw = String(value);
  if (/<!doctype|<html[\s>]/i.test(raw)) return "";
  const text = raw.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
  if (/\bat\s+\S+\s+\(|node_modules|stack trace/i.test(text)) return "";
  if (/(?:bearer|authorization)\s+[a-z0-9._\-]{12,}/i.test(text)) return "";
  if (/(?:password|secret|api[_-]?key|token)\s*[:=]\s*\S{6,}/i.test(text)) return "";
  if (/^[A-Za-z0-9\-_]+\.[A-Za-z0-9\-_]+\.[A-Za-z0-9\-_]+$/.test(text)) return "";
  return text.length > LIMIT ? `${text.slice(0, LIMIT)}…` : text;
}

function sentence(text) {
  return String(text || "").replace(/[.!\s]+$/u, "");
}

// Message lisible pour l'utilisateur. Chaîne vide si la requête a été annulée.
export function apiErrorMessage(error, fallback = "L’opération a échoué. Réessayez.") {
  const base = sentence(fallback) || "L’opération a échoué";
  if (!error) return `${base}.`;
  if (isRequestCanceled(error)) return "";
  const data = error.response?.data;
  const binary = typeof Blob !== "undefined" && (data instanceof Blob || data instanceof ArrayBuffer);
  const status = error.response?.status || (!binary && data && typeof data === "object" ? data.statusCode : undefined);
  const server = binary
    ? ""
    : readable(typeof data === "string" ? data : data?.message) || readable(typeof data === "object" ? data?.error : "");
  if (server) return status ? `${sentence(server)} (erreur ${status}).` : `${sentence(server)}.`;
  if (!error.response) {
    const thrown = readable(error.message);
    const technical = !thrown || /^network error$/i.test(thrown) || /^request failed with status code \d+$/i.test(thrown);
    if (!technical) return `${sentence(thrown)}.`;
    const offline = error.code === "ERR_NETWORK" || error.code === "ECONNABORTED" || /^network error$/i.test(error.message || "") || Boolean(error.request);
    return offline ? `${base}. Connexion au serveur impossible.` : `${base}.`;
  }
  return `${base} (erreur ${status || "inconnue"}).`;
}
